var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c(_vm.header,{directives:[{name:"show",rawName:"v-show",value:(_vm.$showHeader),expression:"$showHeader"}],tag:"component"}),_c('router-view'),_c('FloatChatIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }